import { render, staticRenderFns } from "./manageForm.vue?vue&type=template&id=255735c4&scoped=true"
import script from "./manageForm.vue?vue&type=script&lang=js"
export * from "./manageForm.vue?vue&type=script&lang=js"
import style0 from "./manageForm.vue?vue&type=style&index=0&id=255735c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255735c4",
  null
  
)

export default component.exports